import React, { Component } from 'react';
import CheckDefecto from '../../../Common/Components/CheckDefecto'
import IndividualTab from '../../../Common/Components/IndividualTab'


const checkSoloProcesosActivos = {
    'marginTop': '10%',
    'marginLeft': '45%',
};

class Header extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { checkActivo, selectCheckBox, procesos, administratorSelected, selectTab, administradorasActivas } = this.props;

        const numTabsToShow = 3; 

        let AdministradorasViewTabs = [];
        
        let className = administradorasActivas.length + 1 > numTabsToShow ? 'tabAdministradoraConfProc small ' : 'tabAdministradoraConfProc ';

        administradorasActivas?.map((marca, index) => {
            let active;
            let activeIn;

            if ((administratorSelected == marca.Id)
                || ((administratorSelected == undefined)
                    && index == 0)) {
                active = "active";
                activeIn = "tab-pane fade active in";
            }
            else {
                active = "";
                activeIn = "tab-pane fade";
            }


            AdministradorasViewTabs.push(
                <IndividualTab
                    administrator={administratorSelected !== undefined ? administratorSelected : marca.Id}
                    id={marca.Id}
                    active={active}
                    descripcion={marca.Codigo == 'VISA' ? <div className="icon-visa"></div> : marca.Codigo == 'CABAL' ? <div className="image-cabal-logo procesoLogo"></div> : <div className="image-mastercard-logo-tab  procesoLogo"></div>}
                    key={"IndividualTab_" + marca.Id}
                    handleClick={selectTab}
                    tabIndex={index} 
                    className={className}
                />
            );
        });

        let lastTabIndex = administradorasActivas.length;

        AdministradorasViewTabs.push(
            <IndividualTab
                administrator={0}
                id={0}
                active={administratorSelected === 0 ? "active" : ""}
                descripcion={<div className="image-AD17-logo procesoLogo"></div>}
                key={"IndividualTab_" + 0}
                handleClick={selectTab}
                tabIndex={lastTabIndex} 
                className={className}
            />
        );

        return (
            <div>
                <div className="row top-separator-xs">
                    <div className='col-md-12'>
                        <div className="row">
                            <div className="col-xs-8">
                                <div className="CuentaSeleccionContainer">
                                    {AdministradorasViewTabs}
                                </div>
                            </div>

                            <div className="col-xs-4" >
                                <div className='check-registros-activos-total VistaInstanciaParametro-Filtros-Marign-Top'>
                                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                        <input disabled={false} id={"ProcesosActivos"} type="checkbox" checked={checkActivo} onChange={() => selectCheckBox(!checkActivo, procesos)} />
                                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkActivo ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"ProcesosActivos"}></label>
                                    </div>
                                    <label className="label-primary" htmlFor={"ProcesosActivos"}><p>Visualizar sólo procesos vigentes</p></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default Header;

